module.exports = __webpack_public_path__ + "img/logo-new.701422a1.png";